import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Features } from './components/Features';
import { Origin } from './components/Origin';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Purchase } from './components/Purchase';
import { FinalCTA } from './components/FinalCTA';
import { RecentPurchasePopup } from './components/RecentPurchasePopup';
const PIXEL_ID = '1346219280728309';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if ((window as any).fbq) return;
    (function (f: any, b: Document, e: string, v: string) {
      let n: any, t: HTMLScriptElement, s: HTMLScriptElement | null;
      if (f.fbq) return;
      n = f.fbq = function () {
        // eslint-disable-next-line prefer-rest-params
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0] as HTMLScriptElement | null;
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    const fbq = (window as any).fbq;
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
    // <noscript> fallback image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-cream-100 font-sans selection:bg-burgundy-200 selection:text-burgundy-900" data-id="element-0">
      <Hero data-id="element-1" />
      <Story data-id="element-2" />
      <Features data-id="element-3" />
      <Origin data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Purchase data-id="element-6" />
      <Testimonials data-id="element-7" />
      <FinalCTA data-id="element-8" />

      <RecentPurchasePopup data-id="element-9" />

      <footer className="bg-brown-900 text-cream-100/50 py-8 text-center text-sm" data-id="element-10">
        <div className="container mx-auto px-4" data-id="element-11">
          <p data-id="element-12">
            © {new Date().getFullYear()} Del Horno a Tu Primer Ingreso. Todos
            los derechos reservados.
          </p>
          <p className="mt-2 text-xs opacity-70" data-id="element-13">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}